export type AuthUser = {
  id: number;
  google_sub: number;
  email: string;
  given_name: string;
  family_name: string;
  picture: string;
  locale: string;
  access_token: string;
  refresh_token: string;
  token_expiry_date: string | null;
  last_login_date: string;
  created_date: string | null;
  last_modified_date: string;
  selected_location: LocalLocation;
  no_licenses: number | null;
  subscription_end: string | null;
  subscription_renewable: boolean;
};

export type AccountContact = {
  given_name: string;
  family_name: string;
  email: string;
};

export enum DefendResponseType {
  NONE,
  AI_RESPONSE,
  RECTIFICATION,
}

export type LocalLocation = {
  id: string;
  location_id: string;
  title: string;
  full_address: string;
  primary_category: string;
  owner_contact: AccountContact;
  created_date: string | null;
  last_modified_date: string;
  auto_pilot_activated: boolean;
  auto_request_activated: boolean;
  defend_response_type: DefendResponseType;
  place_id: string;
  album_id: string;
};
